(function () {

  'use strict';

  function pxSoftwareContextMenu(
    $timeout, $window
    ) {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        selectedTab: '=selectedTab',
        contextPosition: '=contextPosition',
        resource: '=resource',
        callback: '&callback'
      },
      // TEMPLATE USAGE -> px-software-context-menu // 1 USAGE inside of /softwareDistribution path THIS IS APPROVED
      templateUrl: 'app/components/softwareDistribution/_softwareContextMenu/softwareContextMenu.template.html',
      link: function (scope, element, attrs) {


        (function() {
          initContexContent();
        })();

        scope.$watch(function() {
          return scope.contextPosition;
        }, function(oldVal, newVal){
          if (oldVal !== newVal) {
            initContexContent();
          }
        })

        function initContexContent() {
          checkValidPostion (scope.contextPosition.left, scope.contextPosition.top) 
        };

        function checkValidPostion (left, top) {
          var offsetX = 60;
          var offsetY = 100;
          
          left = left - offsetX;
          var containerWidth = angular.element('.container').innerWidth();

          $timeout(function() {
            var menuHeight = angular.element('.context-content-container').innerHeight();
            var menuWidth = angular.element('.context-content-container').innerWidth();


            if ($window.innerHeight <= 768) {
              var screenCenter = $window.innerHeight / 2;
              var menuCenter = menuHeight / 2;
              top = screenCenter - menuCenter;
            } else if ((menuHeight + top) > $window.innerHeight) {
              top = ($window.innerHeight - menuHeight) / 2;
            } else {
              top = top - offsetY;
            }

            if (containerWidth <= 1024) {
              var screenCenter = containerWidth / 2
              var menuCenter = menuWidth / 2;
              left = screenCenter - menuCenter; 
              
            } else if ((menuWidth + left) > containerWidth) {
              left = left - menuWidth;
            }

            // if ((menuHeight + top) > $window.innerHeight) {
            //   if (scope.selectedTab.order) {
            //     top = (top - menuHeight) + (scope.selectedTab.order * 30);
            //   } else {
            //     top = ($window.innerHeight - menuHeight) / 2;
            //   }
            // } else {
            //   top = top - offsetY;
            // }

            // if ((menuWidth + left) > containerWidth) {
            //   left = left - menuWidth;
            // }

            angular.element('.context-content-container').css({left: left , top: top});
            angular.element('.context-content-container').css({display: 'block'});
          }, 50)
        }

        scope.closePopup = function () {
          scope.callback({selectedContextMenuItem: null, contextPosition: null, contextContent: null});
        }

        scope.$on('$destroy', function() {
          angular.element('.context-content-container').css({display: 'none'});
        });

      }
    }
  }



  pxSoftwareContextMenu.$inject = ['$timeout', '$window'];

  angular
    .module('printix-admin')
    .directive('pxSoftwareContextMenu', pxSoftwareContextMenu);

})();